{
  if (!window.__heroCatStickyInit) {
    window.__heroCatStickyInit = true;

    const init = () => {
      const cat = document.querySelector('.collection-hero__categories');
      if (!cat) return;

      const placeholder = document.createElement('div');
      placeholder.className = 'collection-hero__categories-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      cat.before(placeholder);

      let naturalTop = Infinity;
      let pinned = false;
      let ticking = false;

      const readOffset = () => {
        const s = getComputedStyle(document.documentElement);
        return parseFloat(s.getPropertyValue('--header-height')) || 0;
      };

      const measure = () => {
        placeholder.style.setProperty('--cat-pinned-height', `${cat.offsetHeight}px`);
        const target = pinned ? placeholder : cat;
        const rect = target.getBoundingClientRect();
        naturalTop = rect.top + window.scrollY;
      };

      const apply = () => {
        const should = window.scrollY + readOffset() >= naturalTop;
        if (should !== pinned) {
          pinned = should;
          cat.classList.toggle('is-pinned', pinned);
          placeholder.classList.toggle('is-active', pinned);
          measure();
        }
        ticking = false;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(apply);
      };

      const refresh = () => {
        measure();
        apply();
      };

      refresh();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', refresh, { passive: true });
      window.addEventListener('load', refresh);

      const section = cat.closest('.collection-hero') || document.body;
      const ro = new ResizeObserver(refresh);
      ro.observe(section);

      for (const img of section.querySelectorAll('img')) {
        if (!img.complete) {
          img.addEventListener('load', refresh, { once: true });
        }
      }

      setTimeout(refresh, 500);
      setTimeout(refresh, 1500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
}
